// extracted by mini-css-extract-plugin
export var scrollArea = "_of-0";